import { Component, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ConnectedUserProfileComponent } from '../connected-user-profile/connected-user-profile.component';
import { LucideAngularModule, Shield } from 'lucide-angular';

@Component({
  selector: 'app-admin-menu',
  imports: [
    RouterLink,
    RouterLinkActive,
    TranslocoPipe,
    ConnectedUserProfileComponent,
    LucideAngularModule,
  ],
  templateUrl: './admin-menu.component.html',
})
export class AdminMenuComponent {
  private router = inject(Router);
  shieldIcon = Shield;

  menuItems = [
    { label: 'Companies', icon: 'pi pi-building', route: 'company' },
    { label: 'Users', icon: 'pi pi-users', route: 'user' },
    { label: 'Projects', icon: 'pi pi-globe', route: 'projects' },
    {
      label: 'Contributions',
      icon: 'pi pi-credit-card',
      route: 'contributions',
    },
    {
      label: 'AI extraction jobs',
      icon: 'pi pi-file-import',
      route: 'document-jobs',
    },
    { label: 'Mailing List', icon: 'pi pi-envelope', route: 'mailing-list' },
    { label: 'Packs', icon: 'pi pi-box', route: 'pack' },
    { label: 'Emission Factors', icon: 'pi pi-sliders-h', route: 'factors' },
    { label: 'Update Notes', icon: 'pi pi-bell', route: 'update-notes' },
    { label: 'Statistics', icon: 'pi pi-chart-bar', route: 'statistics' },
  ];

  returnToUserPlatform() {
    this.router.navigate(['/home/travel-board']);
  }
}
